var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-container",
        { staticClass: "px-6 pt-4 pb-8", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "7" } },
                [
                  _c("v-autocomplete", {
                    staticClass: "facility-select",
                    attrs: {
                      items: _vm.allFacilities,
                      "item-text": "title",
                      "item-value": "facility_key",
                      multiple: "",
                      chips: "",
                      "deletable-chips": "",
                    },
                    on: {
                      change: function ($event) {
                        _vm.canSave = true
                      },
                    },
                    model: {
                      value: _vm.ownedFacilityKeys,
                      callback: function ($$v) {
                        _vm.ownedFacilityKeys = $$v
                      },
                      expression: "ownedFacilityKeys",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { md: "5" } },
                [
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-green",
                          attrs: { disabled: !_vm.canSave },
                          on: {
                            click: function ($event) {
                              return _vm.saveOwnedFacilities()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("save")]), _vm._v(" Save")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ies-coral",
                          attrs: { disabled: !_vm.ownedFacilityKeys.length },
                          on: {
                            click: function ($event) {
                              return _vm.removeAllOwnedFacilities()
                            },
                          },
                        },
                        [_vm._v("Remove All")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.loadAllFacilities()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("refresh")]), _vm._v(" Refresh")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { href: "/facilities/list", target: "_blank" },
                        },
                        [
                          _c("v-icon", [_vm._v("library_add")]),
                          _vm._v(" Library"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }